import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type HighlightsStoreType = {
    descriptorId: string | null;
    actions: {
        setDescriptorId: (descriptorId: string | null) => void;
    };
};

const useHighlightsStore = create<HighlightsStoreType>((set) => ({
    descriptorId: null,
    actions: {
        setDescriptorId: (descriptorId) => set({ descriptorId }),
    },
}));

export const useHighlightsStoreHighlightedDescriptorId = () => useHighlightsStore((state) => state.descriptorId);
export const useHighlightsStoreActions = () => useHighlightsStore(useShallow((state) => state.actions));

export default useHighlightsStore;
